import { Button, Card, Table, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { Activityservice } from "../services/importfile.service";
import type { ColumnsType } from "antd/es/table";
import { loadAppConfig } from "../../../configs/app-config";

interface IActivityall {
  id: number;
  agendaId: string;
  name: string;
  description: string;
  type: string;
  number: number;
  fixLimit: boolean;
  numberChar: string;
  createDate: string;
  updateDate: string;
}
export interface props {
  dataResult: IActivityall[];
}

export const TableactivityList: React.FC<props> = ({ dataResult }): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const navigate = useNavigate();
  const handleDownloadClick = (row: IActivityall) => {
    Activityservice(apiBaseUrl)
      .findByRefenceId(row.agendaId)
      .then((response) => {
        const link = document.createElement("a");
        link.href = response;
        link.download = "image.png";
        link.click();
      });
  };

  const handleclickincomponents = (event: IActivityall) => {
    navigate("/activitylist/importfile", { state: event });
  };

  const onClickAction = (agendaId: string) => {
    navigate(`/activitylist/activity-list-member/${agendaId}`);
  };

  const onClickCustomize = (agendaId: string) => {
    navigate("/activitylist/costumize-activity-list-member", { state: { agendaId } });
  };

  const columns: ColumnsType<IActivityall> = [
    { key: "no", title: "Name", dataIndex: "name", width: "30%" },
    {
      key: "description",
      title: "Description",
      dataIndex: "description",
      width: "30%",
    },
    { key: "type", title: "Type", dataIndex: "type", width: "5%" },
    { key: "number", title: "Number", dataIndex: "number", width: "5%" },
    { key: "numberChar", title: "Number Char", dataIndex: "numberChar" },
    {
      key: "member",
      title: "Nmember",
      dataIndex: "member",
      render: (value, record: IActivityall, index) => (
        <Button type="link" onClick={() => onClickAction(record.agendaId)}>
          member
        </Button>
      ),
    },
    {
      key: "customize",
      title: "Customize",
      dataIndex: "customize",
      render: (value, record: IActivityall, index) => (
        <Button type="link" onClick={() => onClickCustomize(record.agendaId)}>
          customize
        </Button>
      ),
    },
    {
      key: "number",
      title: "Action",
      dataIndex: "number",
      align: "center",
      render: (event: string, row: IActivityall) => {
        if (!row.fixLimit) {
          return (
            <>
              <Button type="link" onClick={() => handleclickincomponents(row)}>{`import user`}</Button>
            </>
          );
        } else {
          return <Button onClick={() => handleDownloadClick(row)}>Dowload Qr-Code</Button>;
        }
      },
    },
  ];
  return (
    <div>
      <Card>
        <Table size="small" dataSource={dataResult} columns={columns} rowKey={`id`} scroll={{ x: 1500 }} />
      </Card>
      {/* {dataResult && (
        <ImportFile
          //   setStatusRefesh={setStatusRefesh}
          data={dataResult}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          onCloseDialog={() => setIsModalOpen(false)}
          onOkDialog={() => setIsModalOpen(false)}
        />
      )} */}
    </div>
  );
};
